import { Box, SpaceBetween } from '@cloudscape-design/components';
import { ConfigurationObject } from '../../services/configs-api';
import { resolveConfigName } from './format-utils';

interface IntentDetailProps {
  config: ConfigurationObject;
  allConfigs: ConfigurationObject[];
}

/**
 * Human-readable detail view for Intent config type.
 * Shows: Routes To (destination type + name), Condition (plain English)
 */
export function IntentDetail({ config, allConfigs }: IntentDetailProps) {
  const payload = config.payload ?? {};

  const destinationType = (payload.destinationType as string) ?? '—';
  const destinationValue = (payload.destinationValue as string) ?? '';
  const condition = (payload.conditionalExpression as string) ?? '';

  // Resolve destination to human-readable name
  const destinationDisplay = ['queue', 'menu', 'deflect', 'agent'].includes(destinationType)
    ? resolveConfigName(destinationValue, allConfigs)
    : destinationValue || '—';

  const conditionDisplay = condition
    ? condition
    : 'Always routes (no condition)';

  return (
    <SpaceBetween size="m">
      <div>
        <Box variant="awsui-key-label">Routes To</Box>
        <div>
          <strong>{destinationType.charAt(0).toUpperCase() + destinationType.slice(1)}</strong>
          {' → '}
          {destinationDisplay}
        </div>
      </div>

      <div>
        <Box variant="awsui-key-label">Condition</Box>
        <Box variant="p" color="text-body-secondary">
          {conditionDisplay}
        </Box>
      </div>
    </SpaceBetween>
  );
}
